import { API_HOST, getHttpPostOptions, getHttpGetOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/notification`;

const getViewNotificationsEndpoint = () => `${getEndpoint()}/retrieve`;
export const getViewNotificationsRequest = (receiverExternalReference) => [
  getViewNotificationsEndpoint(),
  getHttpPostOptions(receiverExternalReference),
];

const getAcknowledgeNotificationEndpoint = (externalReference) => `${getEndpoint()}/acknowledge/${externalReference}`;
export const getAcknowledgeNotificationRequest = (externalReference) => [
  getAcknowledgeNotificationEndpoint(externalReference),
  getHttpGetOptions(),
];

const getAcknowledgeNotificationsForChatEndpoint = () => `${getEndpoint()}/acknowledge/messages`;
export const getAcknowledgeNotificationsForChatRequest = (data) => [
  getAcknowledgeNotificationsForChatEndpoint(),
  getHttpPostOptions(data),
];
